export const NUMBER_OF_DOWNLOADS = 40;
export const NavHeight = 72;
export const appLink = "https://gromo.co.in/XKiY";
